/* Evora — pase AOV. Regalos de recompensa, código de descuento, temporizador de bolsa y acabados en upsells.
   Reutiliza el carrito del tema (Evora.renderCart / Ajax Cart). Sin dependencias. */
(function () {
  'use strict';
  var E = window.Evora = window.Evora || {};
  var SECTION = 'cart-drawer';
  var R = E.routes || {};
  var root = (R.root || '/').replace(/\/?$/, '/');
  var URL_UPD = (R.cartUpdate || '/cart/update') + '.js';
  var URL_ADD = (R.cartAdd || '/cart/add') + '.js';
  var URL_CART = (R.cart || '/cart') + '.js';

  function q(s, c) { return (c || document).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function storage(name) {
    try { var s = window[name]; s.setItem('__ev', '1'); s.removeItem('__ev'); return s; } catch (e) { return null; }
  }
  var LS = storage('localStorage') || storage('sessionStorage');
  var SS = storage('sessionStorage');
  var isCartPage = function () { return !!q('[data-cart-page]'); };

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok || d.status) throw new Error(d.description || d.message || 'Error');
          return d;
        });
      });
  }
  function getCart() { return fetch(URL_CART, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  var selfRender = false;
  function paint(d) {
    if (!d) return;
    selfRender = true;
    try { if (E.renderCart) E.renderCart(d.sections, typeof d.item_count === 'number' ? d.item_count : undefined); }
    finally { selfRender = false; }
  }
  function withSections(body) { body.sections = [SECTION]; body.sections_url = window.location.pathname; return body; }

  /* ------------------------------------------------------------
     Regalos de recompensa: se añaden al llegar al importe y se quitan al bajar.
     Solo se quedan si Shopify los cobra a 0 € (descuento real). Nunca 2 del mismo paso.
     ------------------------------------------------------------ */
  function cfg() {
    var el = q('#CartDrawer [data-rewards-cfg]') || q('[data-rewards-cfg]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function isGift(i) { return i && i.properties && i.properties._evora_reward; }
  function failed(step) { return !!(SS && SS.getItem('evoraGiftFail' + step) === '1'); }
  var syncing = false, again = false;

  function syncGifts(force) {
    var c = cfg();
    if (!c || (!c.sync && !force)) return Promise.resolve();
    if (syncing) { again = true; return Promise.resolve(); }
    syncing = true;
    var changed = false;
    return ser(function () { return getCart().then(function (cart) {
      var gl = cart.items.filter(isGift);
      var base = cart.total_price - gl.reduce(function (a, i) { return a + i.final_line_price; }, 0);
      var gifts = c.auto ? (c.gifts || []) : [];
      var updates = {}, adds = [];
      gifts.forEach(function (g) {
        var lines = gl.filter(function (i) { return String(i.properties._evora_reward) === String(g.step); });
        var want = base >= g.min && !failed(g.step);
        if (want) {
          if (!lines.length) adds.push({ id: g.variant, quantity: 1, properties: { _evora_reward: String(g.step) } });
          lines.forEach(function (l, k) { var n = k === 0 ? 1 : 0; if (l.quantity !== n) updates[l.key] = n; });
        } else {
          lines.forEach(function (l) { updates[l.key] = 0; });
        }
      });
      gl.forEach(function (l) {
        var known = gifts.some(function (g) { return String(g.step) === String(l.properties._evora_reward); });
        if (!known) updates[l.key] = 0;
      });
      var p = Promise.resolve();
      if (Object.keys(updates).length) { changed = true; p = p.then(function () { return post(URL_UPD, { updates: updates }); }); }
      if (adds.length) {
        changed = true;
        p = p.then(function () { return post(URL_ADD, { items: adds }); })
          .then(getCart)
          .then(function (c2) {
            var bad = c2.items.filter(function (i) { return isGift(i) && i.final_line_price > 0; });
            if (!bad.length) return null;
            var u = {};
            bad.forEach(function (b) { u[b.key] = 0; if (SS) SS.setItem('evoraGiftFail' + b.properties._evora_reward, '1'); });
            console.warn('[Evora] El regalo no sale a 0 € en Shopify (falta el descuento automático al 100 %). Se ha retirado de la bolsa.');
            return post(URL_UPD, { updates: u });
          })
          .catch(function (e) { console.warn('[Evora] No se pudo añadir el regalo: ' + e.message); });
      }
      return p;
    }).then(function () {
      if (!changed) return null;
      if (isCartPage()) { window.location.reload(); return null; }
      return post(URL_UPD, withSections({ updates: {} })).then(paint);
    }); }).catch(function (e) {
      console.warn('[Evora] Recompensas: ' + e.message);
    }).then(function () {
      syncing = false;
      if (again) { again = false; return syncGifts(); }
      return null;
    });
  }
  E.syncRewards = syncGifts;

  /* ------------------------------------------------------------
     Código de descuento (mecanismo nativo: /cart/update.js con "discount").
     ------------------------------------------------------------ */
  function codeMsg(ok, text) {
    var m = q('#CartDrawer [data-cx-code-msg]') || q('[data-cx-code-msg]');
    var d = m && m.closest('details');
    if (d) d.open = true;
    if (!m) return;
    m.textContent = text;
    m.className = 'cx-code__msg ' + (ok ? 'is-ok' : 'is-bad');
    m.hidden = false;
  }
  function currentCodes(f) { return (f.getAttribute('data-codes') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
  function ser(task) { return E.cartSerial ? E.cartSerial(task) : task(); }
  function sendCodes(codes) { return ser(function () { return post(URL_UPD, withSections({ discount: codes.join(',') })); }); }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest ? e.target.closest('[data-cx-code]') : null;
    if (!f) return;
    e.preventDefault();
    var inp = q('input[name="code"]', f);
    var code = (inp.value || '').trim();
    if (!code) { inp.focus(); return; }
    var okText = f.getAttribute('data-ok') || 'Código aplicado';
    var badText = f.getAttribute('data-bad') || 'Este código no es válido';
    var existing = currentCodes(f);
    if (existing.some(function (x) { return x.toLowerCase() === code.toLowerCase(); })) { codeMsg(true, okText); return; }
    var btn = q('button', f);
    btn && btn.classList.add('is-loading');
    sendCodes(existing.concat(code)).then(function (d) {
      if (!Array.isArray(d.discount_codes)) {
        window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
        return null;
      }
      var hit = d.discount_codes.filter(function (x) { return String(x.code).toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) {
        if (isCartPage()) { window.location.reload(); return null; }
        paint(d);
        codeMsg(true, okText);
        syncGifts();
        return null;
      }
      return sendCodes(existing).then(function (d2) { paint(d2); codeMsg(false, badText); });
    }).catch(function () {
      codeMsg(false, badText);
    }).then(function () { btn && btn.classList.remove('is-loading'); });
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cx-code-remove]');
    if (!rm) return;
    e.preventDefault();
    var f = q('#CartDrawer [data-cx-code]') || q('[data-cx-code]');
    var code = rm.getAttribute('data-cx-code-remove').toLowerCase();
    var rest = f ? currentCodes(f).filter(function (x) { return x.toLowerCase() !== code; }) : [];
    rm.disabled = true;
    sendCodes(rest).then(function (d) {
      if (isCartPage()) { window.location.reload(); return; }
      paint(d);
      syncGifts();
    }).catch(function () { rm.disabled = false; });
  });

  /* ------------------------------------------------------------
     Acabado (variante) en upsells y cross-sell: cambia el id del botón Añadir.
     ------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-qa-opt]');
    if (!o) return;
    e.preventDefault();
    var w = o.closest('[data-qa-wrap]');
    if (!w) return;
    qa('[data-qa-opt]', w).forEach(function (x) { x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
    var b = q('[data-quick-add]', w);
    if (b) b.setAttribute('data-quick-add', o.getAttribute('data-qa-opt'));
    var im = q('[data-qa-img]', w);
      var src = o.getAttribute('data-img');
      if (im && src) { im.removeAttribute('srcset'); im.src = src; }
      var pr = q('[data-qa-price]', w);
    if (pr && o.getAttribute('data-price') && E.formatMoney) {
      pr.textContent = E.formatMoney(Number(o.getAttribute('data-price')));
    }
  });

  /* ------------------------------------------------------------
     Temporizador de bolsa: empieza con la primera pieza, persiste al recargar,
     no se reinicia al abrir/cerrar, desaparece al llegar a 0 y se resetea con la bolsa vacía.
     ------------------------------------------------------------ */
  var TK = 'evoraCartTimerStart';
  var tmr = null;
  function itemCount() {
    var el = q('#CartDrawer [data-cart-itemcount]') || q('[data-cart-itemcount]');
    return el ? (parseInt(el.getAttribute('data-cart-itemcount'), 10) || 0) : null;
  }
  function timerStart() {
    var n = itemCount();
    if (n === null) return null;
    if (n === 0) { if (LS) LS.removeItem(TK); return null; }
    var start = LS ? parseInt(LS.getItem(TK), 10) : NaN;
    if (!start || isNaN(start) || start > Date.now()) {
      start = Date.now();
      if (LS) LS.setItem(TK, String(start));
    }
    return start;
  }
  function tick() {
    var els = qa('[data-cart-timer]');
    var start = timerStart();
    if (!els.length || !start) {
      els.forEach(function (el) { el.hidden = true; });
      if (tmr) { clearInterval(tmr); tmr = null; }
      return;
    }
    var live = false;
    els.forEach(function (el) {
      var mins = parseInt(el.getAttribute('data-minutes'), 10) || 12;
      var left = start + mins * 60000 - Date.now();
      if (left <= 0) { el.hidden = true; return; }
      live = true;
      var s = Math.ceil(left / 1000);
      var c = q('[data-cart-timer-clock]', el);
      if (c) c.textContent = Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
      el.hidden = false;
    });
    if (!live && tmr) { clearInterval(tmr); tmr = null; }
  }
  function ensureTimer() {
    tick();
    if (!tmr && qa('[data-cart-timer]').some(function (el) { return !el.hidden; })) tmr = setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------
     Enganches: render del carrito del tema, Theme Editor y carga inicial.
     ------------------------------------------------------------ */
  document.addEventListener('evora:cart:rendered', function () {
    ensureTimer();
    if (!selfRender) syncGifts();
  });
  document.addEventListener('shopify:section:load', function () { ensureTimer(); syncGifts(); });
  ensureTimer();
  syncGifts();
})();
